import { createStore as reduxCreateStore, applyMiddleware } from 'redux';
import api from './store/config/api';
import file from './store/config/file';
import userSessionCookie from './store/config/userSessionCookie';
import logger from './store/config/logger';
import errorLogger from './store/config/errorLogger';
import analytics from './store/config/analytics';
import debugging from './store/config/debugging';
import feature from './store/config/feature';
import localStore from './store/config/localStorage';
import reducers from './reducers';
import { composeBuilder } from './util/compose';
import context from './util/context';
import subdomain from './util/subdomain';
import thunk from 'redux-thunk';

const composeEnhanced = composeBuilder(context);

export function createStore(state = {}) {
  return reduxCreateStore(
    reducers,
    state,
    composeEnhanced(
      applyMiddleware(
        thunk,
        api.middleware,
        file.middleware,
        logger,
        errorLogger,
        feature,
        analytics, // must come after API, so calls are tracked
        debugging
      ),
      userSessionCookie.enhancer,
      localStore
    )
  );
}

const store = createStore({
  config: {
    teamName: subdomain()
  }
});

export default store;



// WEBPACK FOOTER //
// ./js/store.js